import {BaseFirebaseModel} from '../bases/baseFirebaseModel';

export class TestResult extends BaseFirebaseModel {
	average: number = 0;
	date: Date = new Date();
	role: string = '';

	constructor(object?: Record<string, unknown>) {
		super();
		Object.assign(this, object);
	}
}
